// Import Lottie player component
import { Player } from '@lottiefiles/react-lottie-player'
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Grid,
  Typography,
} from '@mui/material'
import { green } from '@mui/material/colors'
import { useTranslation } from 'react-i18next' // importing translation functionality
import SendToEmail from '../lottie/success-send-to-email.json' // lottie animation

const SuccessSignUp = ({
  email,
  handleChange,
  open,
  setOpen,
}: {
  email: string
  handleChange: (value: number) => void
  open: boolean
  setOpen: (open: boolean) => void
}) => {
  const handleClick = () => {
    setOpen(false)
    handleChange(0)
  }
  const { t } = useTranslation() // translation function

  return (
    <Dialog fullScreen id="gtm__driver_signup_success" open={open}>
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <Grid
          container
          justifyContent="center"
          rowGap={3}
          sx={{
            p: 2,
          }}
        >
          <Grid item xs={12}>
            <Typography
              color={green[900]}
              sx={{ fontWeight: 600 }}
              textAlign="center"
              variant="h3"
            >
              {t('auth.register.success')}
            </Typography>
          </Grid>
          <Grid
            item
            sx={{
              display: 'flex',
              justifyContent: 'center',
            }}
            xs={12}
          >
            <Box
              sx={{
                alignItems: 'center',
                backgroundColor: green[50],
                borderRadius: '100%',
                display: 'flex',
                height: '250px',
                width: '250px',
              }}
            >
              <Player autoplay loop src={SendToEmail} />
            </Box>
          </Grid>
          <Grid item textAlign="center" xs={12}>
            <Typography
              color="GrayText"
              paragraph
              sx={{ m: 0, p: 0 }}
              variant="body1"
            >
              {t('auth.register.we_sent_email')}
            </Typography>
            <Typography variant="subtitle1">{email}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              color="GrayText"
              paragraph
              textAlign="center"
              variant="body2"
            >
              {t('auth.register.check_email')}
            </Typography>
          </Grid>
          <Grid
            item
            sx={{
              display: 'flex',
              justifyContent: 'center',
            }}
            xs={12}
          >
            <Button disableElevation onClick={handleClick} variant="contained">
              {t('auth.register.continue')}
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

export default SuccessSignUp
